import * as React from "react";
import { Dispatch, SetStateAction } from "react";
import MultiAddCerts from "../containers/MultiAddCerts";
import {
  Form,
  FormSelectChoice,
  KeyStringValue,
  KeyValue,
  Query,
  SearchFieldInput,
} from "../interfaces";
import SelectFilterField from "./SelectFilterField";
import TextFilterField from "./TextFilterField";

export default function MultiDropdownInput({
  form,
  setForm,
  selectId,
  initialSearchFieldName = "",
  searchFieldInputLookup,
  formSelectChoices,
  appState,
  updateUi,
  errors,
  formMetaData,
  label,
  select,
  secondarySelectOptions,
  autocompleteFilters,
  pgcApp,
}: {
  form: Form;
  setForm: Dispatch<SetStateAction<any>>;
  searchFieldInputLookup: SearchFieldInput;
  formSelectChoices: FormSelectChoice[];
  selectId: string;
  appState: Query;
  updateUi: (field: string, value: string) => void;
  initialSearchFieldName?: string;
  errors?: Set<String>;
  formMetaData?: KeyValue;
  label?: string;
  select?: boolean;
  secondarySelectOptions?: KeyValue;
  autocompleteFilters?: string;
  pgcApp?: string;
}) {
  const [searchField, setSearchField] = React.useState<KeyStringValue>({
    fieldName: initialSearchFieldName,
  });

  //sets searchField if flag is in appState
  React.useEffect(() => {
    if (appState.ui.updateFormField) {
      setSearchField({ fieldName: appState.ui.updateFormField });
      updateUi("updateFormField", "");
    }
  }, [appState.ui.updateFormField, updateUi]);
  // clear out form properties from the list of dropdown options so when selecting between choices, the previous selection is cleared
  React.useEffect(() => {
    formSelectChoices.forEach((choice: FormSelectChoice) => {
      if (searchField.fieldName !== choice.value) {
        setForm((prevState: KeyStringValue) => ({
          ...prevState,
          [choice.value]: "",
        }));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchField.fieldName]);
  const sharedComponentProps = {
    currentValue: form[searchField.fieldName]
      ? (form[searchField.fieldName] as string)
      : "",

    disabled: searchField.fieldName === "",
    fieldName: searchField.fieldName,
    label: searchFieldInputLookup[searchField.fieldName].label,
    form: form,
    setForm: setForm,
  };

  let inputField;
  if (pgcApp === "Customized Comparisons" && searchField.fieldName === "cert") {
    inputField = (
      <MultiAddCerts {...sharedComponentProps} appState={appState} />
    );
  } else if (select) {
    inputField = (
      <SelectFilterField
        options={
          secondarySelectOptions
            ? secondarySelectOptions[searchField.fieldName]
            : formSelectChoices
        }
        {...sharedComponentProps}
      />
    );
  } else {
    inputField = (
      <TextFilterField
        {...sharedComponentProps}
        apiPath={searchFieldInputLookup[searchField.fieldName].apiPath}
        filter={autocompleteFilters}
        uniqueField={searchFieldInputLookup[searchField.fieldName].uniqueField}
        autoSuggest={searchFieldInputLookup[searchField.fieldName].autoComplete}
        placeholder={searchFieldInputLookup[searchField.fieldName].placeholder}
        regEx={searchFieldInputLookup[searchField.fieldName].regEx}
        error={errors ? errors.has(`${searchField.fieldName}`) : undefined}
        helperText={
          errors && formMetaData && errors.has(`${searchField.fieldName}`)
            ? formMetaData[searchField.fieldName].helperText
            : undefined
        }
      />
    );
  }

  return (
    <>
      <SelectFilterField
        currentValue={searchField.fieldName}
        fieldName="fieldName"
        id={selectId}
        label={label ? label : "Search Type"}
        options={formSelectChoices}
        form={searchField}
        setForm={setSearchField}
      />

      {inputField}
    </>
  );
}
